import React from "react";
import { Link } from "react-router-dom";
import { Play, Clock, MapPin } from "lucide-react";

export default function TVEpisodeCard({ ep, size = "md" }) {
  const big = size === "lg";
  return (
    <Link to={`/tv/${ep.id}`} data-testid={`tv-episode-${ep.id}`} className="group block relative overflow-hidden bg-black rounded-sm">
      <div className={`relative ${big ? "aspect-[16/9]" : "aspect-[4/3]"} overflow-hidden`}>
        <img src={ep.thumbnail} alt={ep.title} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
        {/* Play overlay */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#C9A961] text-black flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
            <Play className="h-6 w-6 md:h-7 md:w-7 fill-current ml-1" />
          </div>
        </div>
        {/* Episode badge */}
        <div className="absolute top-3 left-3 px-2.5 py-1 bg-[#7A1C2B] text-[10px] uppercase tracking-[0.2em] font-bold text-white">
          S{ep.season || 1} · Ep.{ep.episode_number}
        </div>
        {/* Duration */}
        <div className="absolute top-3 right-3 px-2 py-1 bg-black/70 backdrop-blur text-[10px] text-white font-mono flex items-center gap-1">
          <Clock className="h-3 w-3" />{ep.duration_min}′
        </div>
      </div>
      <div className="p-4">
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#C9A961] mb-1 flex items-center gap-1.5">
          <MapPin className="h-3 w-3" />{ep.region}
        </div>
        <h3 className={`editorial-heading ${big ? "text-2xl md:text-3xl" : "text-lg md:text-xl"} leading-tight text-white mb-1`}>{ep.title}</h3>
        {big && <p className="text-sm text-white/70 mt-2 line-clamp-2">{ep.description}</p>}
      </div>
    </Link>
  );
}
